import { render, staticRenderFns } from "./v-text.vue?vue&type=template&id=7d7e64b4&scoped=true&"
import script from "./v-text.vue?vue&type=script&lang=js&"
export * from "./v-text.vue?vue&type=script&lang=js&"
import style0 from "./v-text.vue?vue&type=style&index=0&id=7d7e64b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7e64b4",
  null
  
)

export default component.exports